import { FieldWrapper } from "@ngx-formly/core";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { AuthService } from "src/app/auth/auth.service";
import {
  SaveReviewResponse,
  SurveyAnswerModel,
} from "src/app/shared/models/survey";
import { LookupService } from "src/app/shared/services/lookup.service";
import { NotificationService } from "src/app/shared/services/notification.service";
import { SurveyService } from "src/app/shared/services/survey.service";

export class AnswerReviewFieldWrapper extends FieldWrapper {
  subject = new Subject();

  get isStateEducationAgencyUser() {
    return this.authService.isStateEducationAgencyUser;
  }

  get isAnswerReviewVisible() {
    return (
      this.props.question &&
      this.props.question.isReviewRequired &&
      //this.answer &&
      this.isStateEducationAgencyUser
    );
  }

  get isAnswerReviewAccepted() {
    return this.answer?.status === "approve";
  }

  get isAnswerReviewRejected() {
    return this.answer?.status === "reject";
  }

  get answer() {
    let ans = this.model.answers.find(
      (i) => i.questionId === this.to.question.id
    );
    if (ans) {
      return ans;
    }
    //return new answer so that there is a place to store the review status even if there is no answer
    let answer: Partial<SurveyAnswerModel> = {
      questionId: this.props.question.id,
      status: "",
      reviewedBy: "",
      reviewDate: null,
      reviewText: "",
      updatedOn: null,
      administrativeUnitSurveyId: this.props.administrativeUnitSurveyId,
      answer: "",
      comments: "",
      isActionRequired: false,
    };

    this.model.answers.push(answer);
    return answer;
  }

  get isAnswerReviewChanged() {
    return (
      this.answer?.status === "reset" &&
      this.answer?.reviewDate &&
      this.answer?.reviewDate < this.answer?.updatedOn
    );
  }

  constructor(
    private authService: AuthService,
    private surveyService: SurveyService,
    private lookupService: LookupService,
    private notificationService: NotificationService
  ) {
    super();
    this.subject.pipe(debounceTime(500)).subscribe((value) => {
      let request: SaveReviewResponse = {
        administrativeUnitSurveyId: this.to.administrativeUnitSurveyId,
        questionId: this.to.question.id,
        status: "reject",
        narrative: this.answer.reviewText,
      };
      this.submitAnswerReview(request, true);
      this.notificationService.success("Review has been saved!");
    });
  }

  onApproveAnswerReviewClicked(evt) {
    let request: SaveReviewResponse = {
      administrativeUnitSurveyId: this.to.administrativeUnitSurveyId,
      questionId: this.to.question.id,
      status: "approve",
      narrative: "",
    };
    this.submitAnswerReview(request, false);
    evt.stopPropagation();
    this.notificationService.success("Review has been saved!");
  }

  onRejectAnswerReviewClicked(evt) {
    this.answer.status = "reject";

    if(this.answer.reviewText){
      let request: SaveReviewResponse = {
        administrativeUnitSurveyId: this.to.administrativeUnitSurveyId,
        questionId: this.to.question.id,
        status: "reject",
        narrative: this.answer.reviewText,
      };
      this.submitAnswerReview(request, false);
    }
    evt.stopPropagation();
  }

  onActionRequiredCommentsBlurred(evt) {
    // let request: SaveReviewResponse = {
    //   administrativeUnitSurveyId: this.to.administrativeUnitSurveyId,
    //   questionId: this.to.question.id,
    //   status: "reject",
    //   narrative: this.answer.reviewText,
    // };
    // this.submitAnswerReview(request, false);
    // this.notificationService.success("Review has been saved!");
  }

  onActionRequiredCommentsKeyUp(evt) {
    this.subject.next(evt.target.value);
  }

  onResetAnswerReviewClicked(evt) {
    let request: SaveReviewResponse = {
      administrativeUnitSurveyId: this.props.administrativeUnitSurveyId,
      questionId: this.props.question.id,
      status: "reset",
      narrative: "",
    };
    this.submitAnswerReview(request, false);
    evt.stopPropagation();
    this.formControl.updateValueAndValidity();
    this.notificationService.success("Review has been reset!");
  }

  private submitAnswerReview(request, hideSpinner) {
    this.surveyService.saveReviewResponse(request, hideSpinner).subscribe({
      next: (response: SurveyAnswerModel) => {
        this.lookupService
          .getCurrentWorkFlowStatusChangesForAdministrativeUnitSurvey(
            (this.model as any).administrativeUnitSurvey.workflowStatusId,
            (this.model as any).workflowId,
            (this.model as any).language,
            (this.model as any).administrativeUnitSurvey.id,
            ((this.model as any).hideSpinner = true)
          )
          .subscribe((availableStatusChanges) => {
            this.model.workflowStatusChanges = availableStatusChanges;
            this.answer.status = response.status;
            this.answer.reviewedBy = response.reviewedBy;
            this.answer.reviewDate = response.reviewDate;
            //this.answer.reviewText = response.reviewText;

            this.to.onSubmitAnswerReview(availableStatusChanges);
          });
      },
      error: (error) => {
        console.log(error);
      },
    });
  }
}
